
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","fill":"none","viewBox":"0 0 48 48"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"fill":"#989AB3","fill-rule":"evenodd","d":"M0 9a1 1 0 011-1h46a1 1 0 011 1v2a1 1 0 01-1 1H1a1 1 0 01-1-1V9zm8 14a1 1 0 011-1h30a1 1 0 011 1v2a1 1 0 01-1 1H9a1 1 0 01-1-1v-2zm9 13a1 1 0 00-1 1v2a1 1 0 001 1h14a1 1 0 001-1v-2a1 1 0 00-1-1H17z","clip-rule":"evenodd"}})])
          )
        }
      }
    